<!-- splash screen -->
<div #splashScreen class="app-splash-screen">
  <!--  <span>Please wait</span>-->
  <img (error)="setDefaultPic()" *ngIf="loaderLogo" [attr.src]="loaderLogo" alt="Logo" style="width: 150px">
  <mat-spinner diameter="40" style="border-color: #000000"></mat-spinner>
</div>
